export default __webpack_public_path__ + "static/martina-plantijn-web-bold-italic-4f9ba14605ac426cbaaa4e4ac760317b.woff2";